import React from 'react';
import { BarChart } from '@mui/x-charts';
import { Box, Typography, Tab } from "@mui/material";

const StackedBarChartStatus = ({ data, height = 243, title, xAxisLabel }) => {
  const STATUS_COLORS = {
    created: 'rgba(240, 237, 250, 1)',
    ready_for_validation: 'rgba(209, 202, 235, 1)',
    rejected_awaiting_email: 'rgba(58, 35, 140, 1)',
    processing: 'rgba(162, 150, 204, 1)',
    exception: 'rgba(26, 28, 102, 1)',
    awaiting_erp: 'rgba(123, 106, 184, 1)',
    yet_to_be_extracted: 'rgba(123, 106, 184, 1)',
    checked_out: 'rgba(209, 202, 235, 1)',
    erp_fail: 'rgba(69, 72, 153, 1)',
    submitted_erp: 'rgba(87, 89, 158, 1)',
    rejected_email_sent: 'rgba(103, 84, 173, 1)',
    processed: 'rgba(147, 132, 199, 1)',
    pending: 'rgba(226, 220, 242, 1)',
    rejected: 'rgba(45, 47, 128, 1)',
    erp_pass: 'rgba(84, 62, 163, 1)'
  };

  const ALL_STATUSES = [
    { dataKey: 'created', label: 'Created' },
    { dataKey: 'pending', label: 'Pending' },
    { dataKey: 'checked_out', label: 'Checked out' },
    { dataKey: 'ready_for_validation', label: 'Ready for validation' },
    { dataKey: 'processing', label: 'Processing' },
    { dataKey: 'processed', label: 'Processed' },
    { dataKey: 'awaiting_erp', label: 'Awaiting ERP' },
    { dataKey: 'erp_fail', label: 'Failed to send to ERP' },
    { dataKey: 'submitted_erp', label: 'Submitted ERP' },
    { dataKey: 'rejected_email_sent', label: 'Rejected email sent' },
    { dataKey: 'rejected', label: 'Rejected' },
    { dataKey: 'erp_pass', label: 'ERP Passed' },
    { dataKey: 'exception', label: 'Exception' },
    { dataKey: 'rejected_awaiting_email', label: 'Rejected awaiting email' },
    { dataKey: 'yet_to_be_extracted', label: 'Yet to be extracted' }

  ];


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    // Format as '5 Jun'
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
  };
  const usedKeys = new Set();
  data.forEach(row => {
    Object.entries(row).forEach(([key, value]) => {
      if (key !== 'date' && Number(value) > 0) {
        usedKeys.add(key);
      }
    });
  });

  const filteredSeries = ALL_STATUSES
    .filter(s => usedKeys.has(s.dataKey))
    .map(s => ({
      ...s,
      color: STATUS_COLORS[s.dataKey],
      stack: true,
    })) as any;


  return (
    <Box sx={{ width: "100%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px', backgroundColor: 'var(--white)' }}>
      <Typography variant="h6" component="h4" sx={{ fontSize: '20px', fontWeight: 700, color: '#111', mb: 4 }}>
        {title}
      </Typography>
      <BarChart
        series={filteredSeries}
        xAxis={[
          {
            scaleType: "band",
            dataKey: "date",
            label: xAxisLabel,
            valueFormatter: (value, context) => {
              if (context.location === "tick") {
                return ""
              }
              return formatDate(value).toLowerCase()
            }
          },
        ]}
        yAxis={[
          {
            label: 'Invoices',
          },
        ]}
        dataset={data}
        height={height}
        sx={{
          '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
          '& .MuiChartsAxis-root .MuiChartsAxis-tick': { stroke: 'var(--grey-CCC)' }
        }}
        slotProps={{
          legend: {
            sx: {
              width: '100%',
              marginLeft: "30px",
              height: "40px",
              marginBottom: '20px',
              flexDirection: 'column',
              overflowX: 'auto'
            },
          },
        }}

      />
    </Box>
  );
}
export default StackedBarChartStatus;